<template>
  <v-button v-bind="$attrs" @click="copy">
    <v-icon v-if="hasCopied" icon="check" />
    <v-icon v-else icon="copy" />

    <template v-if="hasCopied">
      {{ $t("components.copyButton.copied") }}
    </template>
    <template v-else>
      <slot />
    </template>

    <input ref="copyInput" type="text" class="copy-input" :value="copyText" />
  </v-button>
</template>

<script>
import copy from "@/lib/copy"

export default {
  props: {
    copyText: { type: String, required: true }
  },

  data() {
    return {
      hasCopied: false
    }
  },

  methods: {
    copy() {
      copy(this.$refs.copyInput)

      this.hasCopied = true

      setTimeout(() => {
        this.hasCopied = false
      }, 2000)
    }
  }
}
</script>
